import styled from 'styled-components';

export const SingleRadioBox = styled.div`
  display: flex;
  height: 155px;
  justify-content: center;
  align-items: center;
`;

export const RadioInnerBackground = styled.div<{ bg: string }>`
  background: url(${props => props.bg}) no-repeat;
  background-position: center center;
  background-size: contain;
  width: 96px;
  height: 76px;
  position: relative;
  z-index: 1;
`;

export const HoverPlayButton = styled.div`
  position: absolute;
  top: 0; bottom: 0;
  left: 0; right: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 9;
  opacity: 0;
  transition: opacity 100ms linear;
  & i {
    font-size: 70px;
    color: #F8941C;
  }
  &:hover {
    opacity: 0.9;
  }
`;

export const FlagBox = styled.div`
  position: absolute;
  z-index: 999;
  right: 4px;
  top: 1px;
`;

export const HeartButton = styled.div<{ isFav: boolean, showFavs: boolean}>`
  position: absolute;
  z-index: 999;
  left: 5px;
  top: 5px;
  transition: opacity 200ms ease;
  opacity: ${props => (props.isFav || props.showFavs) ? 1 : 0.2};
  & i {
    font-size: 17px;
    color: #F23C3C;
  }
`;

export const RadioName = styled.div`
  height: 35px;
  overflow: hidden;
  font-size: 12px;
  background-color: #ededed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const LoadingBox = styled.div`
  position: absolute;
  top: 0; bottom: 0;
  left: 0; right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
`;

export const SingleInner = styled.div`
  width: 196px;
  height: 116px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  transition: all 100ms linear;
  position: relative;
  &:hover {
    transform: translateY(-5px);
    box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 8px;
  }
`;